module.exports = __webpack_public_path__ + "media/images/client-13-f2b89e477d3b16e72ca15dfc840d42e7.png";